import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import useOpenCloseToggle from 'src/common/hooks/useOpenCloseToggle';
import getClassNames from 'src/common/utils/getClassNames';
import Modal from '../Modal';
import type { ModalClassNameModifier } from '../Modal/ModalClassNameModifiers';
import style from './NavModal.module.scss';

type NavModalChildrenProps = {
  close: () => void;
};

type Props = {
  children: ReactNode | ((props: NavModalChildrenProps) => ReactNode);
  heading: ReactNode;
  classNameModifier?: ModalClassNameModifier;
};

const NavModal: FC<Props> = ({ children, heading, classNameModifier }) => {
  const { close, isOpen, toggle } = useOpenCloseToggle();
  return (
    <>
      <button
        type="button"
        onClick={toggle}
        className={getClassNames(style, 'button', classNames({ open: isOpen }))}
        aria-label="Main menu"
      >
        {heading}
      </button>
      <Modal
        label=""
        modalOpen={isOpen}
        closeModal={close}
        className={getClassNames(style, 'modal', classNameModifier)}
      >
        <Modal.Body classNameModifier={classNameModifier}>
          <ul className={getClassNames(style, 'content', classNameModifier)}>
            {typeof children === 'function' ? children({ close }) : children}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NavModal;
